import { EntityBase } from '@provision/entity-types';
import { CustomViewAttribute } from 'src/graphql/entities/custom-view';
import { CustomAttributeColumnRenderer } from 'src/graphql/entities/custom-view/custom-view-config/custom-attributes-bridge';
import {
  CustomComponentsByAttribute,
  getAttributeRawValue,
  renderAttributeValue,
} from './render-attribute-value';

export const AttributeValue = <T extends EntityBase>({
  record,
  column,
  customAttributeRenderer,
  customComponentsByAttribute,
}: {
  record: T;
  column: CustomViewAttribute;
  customAttributeRenderer?: CustomAttributeColumnRenderer;
  customComponentsByAttribute?: CustomComponentsByAttribute;
}) =>
  renderAttributeValue({
    record,
    column,
    rawValue: getAttributeRawValue(record, column, customAttributeRenderer),
    customAttributeRenderer,
    customComponentsByAttribute,
  });
